import {Title, type TitleOrder} from '@mantine/core';
import type {FC} from 'react';

type Props = {
  order?: TitleOrder;
  className?: string;
  title: string;
};

export const SectionTitle: FC<Props> = ({order = 1, className, title}) => {
  return (
    <Title
      order={order}
      className={`${String(
        className,
      )} mb-16 border-t-4 border-primary-1 bg-white p-16 text-lg text-primary-1 pc:px-32`}
    >
      {title}
    </Title>
  );
};
